"use strict";

exports.__esModule = true;
exports.default = void 0;
var windowMock = {
  screen: {
    orientation: undefined
  },
  addEventListener: function addEventListener() {
    return void 0;
  }
};
var _default = windowMock;
exports.default = _default;